import React, { Dispatch, useState } from 'react';
import { EventContentArg } from '@fullcalendar/core';
import { AttendanceToolTip } from '../AttendanceToolTip';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { AttendanceOperatingTimeEditModal } from '../AttendanceOperatingTimeEditModal';

type TProps = {
  eventContent: EventContentArg;
  constructId: number;
  setIsLoading: Dispatch<boolean>;
};

export const EventContent: React.FC<TProps> = (props: TProps) => {
  const { eventContent, constructId, setIsLoading } = props;

  const attendance: any = eventContent.event.extendedProps.attendance;
  let scheduleText = attendance.start_date;
  if (attendance.end_date) {
    scheduleText += ` - ${attendance.end_date}`;
  }
  const attendanceManageEvent = attendance.attendance_manage_event_list.filter(
    (i: any) => i.id == eventContent.event.id
  )[0];

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <>
        <AttendanceToolTip
          title={
            <div>
              {eventContent.event.title}
              <br />
              {scheduleText}
              {attendance.is_alerted && (
                <>
                  <div className='event-title-alert-icon'>
                    <ReportProblemIcon />
                  </div>
                </>
              )}
            </div>
          }
        >
          <div style={{ textAlign: 'center' }} onClick={() => setIsOpen(true)}>
            {eventContent.event.title}
          </div>
        </AttendanceToolTip>
        <AttendanceOperatingTimeEditModal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          id={attendanceManageEvent.id}
          artificial={attendanceManageEvent.artificial}
          constructId={constructId}
          setIsLoading={setIsLoading}
        />
      </>
    </>
  );
};
